//----------------imports--------------------------
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  AppBar,
  Checkbox,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Breadcrumbs,
  Link,
  Snackbar,
  Alert,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import { SETTINGS_API_20, SETTINGS_API_24 } from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";

const BillFormat = () => {
  //---------------------hooks---------------
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // New state for snackbar severity
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const styles = useStyles(theme);
  const [checked, setChecked] = useState([]);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);
  //----------------------------functions------------------
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_20, "get", {
        STS: CON_STATUS_ACTIVE,
      });
      setProducts(mapResultToRows(result));

      const selectedData = await externalgetApi(SETTINGS_API_24, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });

      if (selectedData && selectedData[0]?.JTEXT) {
        const parsedSelectedOptions = JSON.parse(selectedData[0].JTEXT);
        setChecked(parsedSelectedOptions);
      }

      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      BILLOPTCODE: item.BILLOPTCODE,
      BILLOPTION: item.BILLOPTION,
      DISPSEQ: item.DISPSEQ,
    }));
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.findIndex(
      (item) => item.BILLOPTCODE === value.BILLOPTCODE
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setError(null);
  };
  //post api
  const handleConfirm = async () => {
    const payload = {
      idno: "",
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      jtext: checked.map((item) => ({
        billoptcode: item.BILLOPTCODE,
        billoption: item.BILLOPTION,
      })),
      enuser: USERNAME,
      sts: CON_STATUS_ACTIVE,
    };

    try {
      const response = await externalpostApi(SETTINGS_API_24, payload);
      console.log("Post response:", response);

      setSnackbarMessage("Options saved successfully!");
      setSnackbarSeverity("success"); // Set severity to success
      setOpenSnackbar(true); // Open snackbar on success
    } catch (err) {
      console.error("Error posting data:", err);
      alert("Failed to save options.");
      setSnackbarMessage("Failed to delete the order.");
      setSnackbarSeverity("error"); // Set severity to error
      setOpenSnackbar(true);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data: {error.message}</div>;
  }

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">Bill Option</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} ml={0}>
            <Box sx={{ ...styles.col_1, marginLeft: "0" }}>
              <Box
                sx={{
                  ...styles.cb_col_title,
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Typography>Bill Display Options</Typography>
              </Box>
              <Box
                width={"100%"}
                display={"flex"}
                justifyContent={"space-between"}
                height={"65vh"}
                overflow={"auto"}
              >
                <Box>
                  <List sx={{ width: "100%", ml: 0 }}>
                    {products
                      .slice(0, Math.ceil(products.length / 2))
                      .map((item) => {
                        const labelId = `checkbox-list-label-${item.BILLOPTCODE}`;
                        return (
                          <ListItem key={item.id} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(item)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.some(
                                    (checkedItem) =>
                                      checkedItem.BILLOPTCODE ===
                                      item.BILLOPTCODE
                                  )}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={item.BILLOPTION}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </Box>
                <Box>
                  <List
                    sx={{
                      width: "100%",
                    }}
                  >
                    {products
                      .slice(Math.ceil(products.length / 2))
                      .map((item) => {
                        const labelId = `checkbox-list-label-${item.BILLOPTCODE}`;
                        return (
                          <ListItem key={item.id} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(item)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.some(
                                    (checkedItem) =>
                                      checkedItem.BILLOPTCODE ===
                                      item.BILLOPTCODE
                                  )}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={item.BILLOPTION}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ ...styles.col_1, marginLeft: "0", width: "100%" }}>
              <Box
                sx={{
                  ...styles.cb_col_title,
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <Typography>Bill Format</Typography>
              </Box>
              <Box
                width={"100%"}
                display={"flex"}
                flexWrap={"wrap"} // Enable wrapping for grid layout
                overflow={"auto"}
                height={"60vh"}
                alignContent={"flex-start"}
                justifyContent={"flex-start"}
                mt={2}
              >
                {checked.map((item, index) => (
                  <Grid item xs={12} sm={12} md={6} key={index}>
                    <Box
                      sx={{
                        borderBottom: "1px solid #ccc",
                        textAlign: "left",
                        my: 1,
                        pb: 2,
                        mx: 2,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CheckIcon
                        sx={{
                          color: theme.palette.system.success,
                        }}
                      />
                      <Typography pl={1} variant="body2">
                        {item.BILLOPTION}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Box>
              <Box
                width={"100%"}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"flex-end"}
              >
                <Button
                  variant="contained"
                  sx={{
                    ...styles.btn_primary,
                    width: "20%",
                    alignItems: "flex-end",
                    display: "flex",
                  }}
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbarSeverity} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BillFormat;
